/** This environment is used for development in vaquinha-dev.web.app.
 * Use it with flag the --configuration=development */
import { Environments } from './environments.enum';
import { APP_VERSION, Environment } from './environment.interface';
const env = Environments.STAGING;
export const environment: Environment = {
  env,
  appVersion: `${APP_VERSION}-${env}`,
  useEmulators: false,
  production: false,
  publicApiUrl: 'https://public-api-staging.vaki.co/v0',
  firebaseConfig: {
    apiKey: 'AIzaSyAHplWWdLfuRRoqXhB7FTScwI65X6O3cUg',
    authDomain: 'auth-dev.vaki.co',
    databaseURL: 'https://vaquinha-dev.firebaseio.com',
    projectId: 'vaquinha-dev',
    storageBucket: 'vaquinha-dev.appspot.com',
    messagingSenderId: '393842000015',
    appId: '1:393842000015:web:f07a73bd0c826eb9',
    measurementId: 'G-64B4H9YQDQ'
  },
  mercadopago: {
    key: 'TEST-2f614465-ac25-4aa6-8a30-8a86add1da9b',
    notification_url:
      'https://us-central1-vaquinha-dev.cloudfunctions.net/mercadopagoWebhookEndpoint'
  },
  stripe_key: 'pk_test_b  lonqhVhrnQit15Krl5n4gz7',
  stripe_key_mx:
    'pk_test_51Mz3HYFv0YLOxoQnpa5rJzaU9puI8dywDYQ2TtUOqbiAGn7ZH07Esxmzw51uqIgYEyPCdI8wxefXvbOKa5Ba2eLT00fjNPs1Jz',
  paypal_mx: {
    client_id:
      'AWT4ykNs9yKyRpGXxdtrMUZ4psa95ZRlpbgbqz3G1Tp0hLRtb6C4dMP_XJ4J1vW-mnuZ2mJs2f7fbikF'
  },
  intercom: {
    appId: 'bqal3lrb'
  },
  hostUrl: 'https://staging.vaki.co',
  cryptoLandingUrl: 'https://cripto-stg.vaki.co',
  apiVakiURL: 'https://us-central1-vaquinha-dev.cloudfunctions.net/api',
  lolaCreateVakiUrl:
    'https://us-central1-vaquinha-dev.cloudfunctions.net/lolaCreateVaki',
  adminUid: 'f5P1J1xTXobgga3rbGJ0lHXC29n1',
  adminEmail: 'gabriela@vaki.co',
  froalaKey: '5OA4gG5E3E3G3B4A2D-13uenoD3kfvC2B1F1G1B4D4G3B1B8C6==',
  algolia: {
    appId: 'YAKUXKWQES',
    apiKey: '3c0ab8160d7b540a173380366288d456',
    indexes: {
      vakis: 'dev_vakis'
    }
  },
  googleTagManager: {
    id: 'GTM-KXG9PGW',
    auth: 'mlr6ba24QuxPk6VatbxHew',
    env: 'env-39'
  },
  featureFlagsDefault: {
    'vaki-sites': true,
    'vaki-gifts': true,
    'vaki-sponsors': true,
    'algolia-recommend': false
  },
  recaptcha: {
    siteKey: '6Le8WzAsAAAAAEBYGzc5_pQp-iiO8QzFPoFNbLPz',
    appCheckDebugToken: 'fd2f99dd-8fe4-4adf-8037-c9d1ea56cd7f'
  },
  privyAppId: 'cm1gof25u06pky527ewdhvby2',
  platformHash:
    '0x4c058b804607bffa2a4f826cf9046839e093a7df30372651972da76ba25c3042',
  campaignInfoFactoryAddress: '0x76D681579631fEAAad4cd941B972e83dD7d165F2',
  pledgeTokenAddress: '0x092CD39647c3bd6bD05A3B58e769332395E830F7',
  chainId: 11142220,
  rpcUrl: 'https://forno.celo-sepolia.celo-testnet.org',
  platformAdminWalletAddress: '0x2e70f37751e01E2A36A38f2F3AF11FAb929f2204',
  siigo: {
    fv_id: 27860,
    seller_id: 856,
    payment_method: 8149,
    product_id: 'TKK870'
  },
  whatsapp: {
    accountSid: 'ACd65eda77606b409a51bae4e31a72a630',
    authToken: '265607819d5471f9e5961e790394c627',
    phoneNumber: '+13153258202',
    webhookUrl: 'http://localhost:3333/v0/webhooks/whatsapp'
  },
  // Verified live 2026-09-29 (see docs/integrations/whatsapp-number-binding.md).
  whatsappLinkPhoneNumber: '+5215646882543',
  sentry: {
    // Staging is where AC3 (PII scrubbing) gets verified against a real
    // Sentry project before prod is ever considered — enabled here on
    // purpose. See docs/operations/error-tracking-runbook.md.
    //
    // The DSN is NOT a secret: it is public by design and ships inside the
    // browser bundle. What protects the project from anyone who reads it is
    // the Allowed Domains list in Sentry (Project Settings > Client Security),
    // not the secrecy of this string. The CI auth token is the actual secret,
    // and it lives in GitHub secrets, never here.
    enabled: true,
    dsn: 'https://b5d21c67b3d8486dbf3b70b23e3c4312@o986905.ingest.us.sentry.io/5943692',
    // Full capture on staging: traffic is low and AC3 verification needs
    // every event. Production starts lower, calibrated against the volume
    // this staging window actually measures.
    sampleRate: 1
  }
};
